webpackJsonp([7],{

/***/ 1:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IS_PROD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return uuid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return encryptPhone; });
/* harmony export (immutable) */ __webpack_exports__["k"] = setRouteParam;
/* harmony export (immutable) */ __webpack_exports__["e"] = formatTime;
/* unused harmony export base64toBlob */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getSource; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Log__ = __webpack_require__(19);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Device__ = __webpack_require__(15);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Device__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Cookie__ = __webpack_require__(9);
/* unused harmony reexport Cookie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Request__ = __webpack_require__(6);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__Request__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Random__ = __webpack_require__(20);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_5__Random__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Wechat__ = __webpack_require__(21);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__Wechat__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Bridge__ = __webpack_require__(10);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__Bridge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LocalStorage__ = __webpack_require__(16);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__LocalStorage__["a"]; });










var IS_PROD = "production" === 'production';

function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
    return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
  });
}

var uuid = uuidv4;

var encryptPhone = function encryptPhone() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(str).replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3');
};

function setRouteParam() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(options).reduce(function (prev, next) {
    prev.push(next + '=' + encodeURIComponent(options[next]));
    return prev;
  }, []).join('&');
}

function add0(m) {
  return m < 10 ? '0' + m : m;
}

function formatTime(shijianchuo) {
  var timeMs = shijianchuo || +new Date().getTime();
  var time = new Date(timeMs);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s) + '.' + timeMs % 1000;
}

function base64toBlob(base64Data) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'png';

  var byteString = window.atob(base64Data.split(',')[1]);
  var ab = new window.ArrayBuffer(byteString.length);
  var ia = new window.Uint8Array(ab);
  for (var i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new window.Blob([ab], {
    type: 'image/' + type
  });
}

var getSource = function getSource() {
  var ua = window.navigator.userAgent.toLowerCase();
  var source = '';
  if (/micromessenger/i.test(ua)) {
    source = 'wx_app';
  } else {
    source = 'app';
  }
  return source;
};

/***/ }),

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bridgeInvoke; });
/* unused harmony export bridgeVerCheck */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return wxRedirectTo; });
/* unused harmony export aliRedirectTo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return wxNavigateTo; });
/* unused harmony export aliNavigateTo */
/* unused harmony export wxNavigateBack */
/* unused harmony export aliNavigateBack */
/* unused harmony export wxPostMessage */
/* unused harmony export aliPostMessage */
/* unused harmony export wxGetLocation */
/* unused harmony export wxShare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_wechat_index_js__ = __webpack_require__(13);






__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_wechat_index_js__["a" /* default */]);

var SUPPORT_MAP = {
  checkAppLoginStatus: {
    min: 1130
  },
  goAppLogin: {
    min: 1130
  }
};

var wx = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].wechat;

var Bridge = {
  invoke: function invoke(funName, cb) {
    var parameter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var callback = cb || function () {};

    if (window.__wxjs_environment === 'miniprogram') {
      if (wx.miniProgram) {}
      return;
    }

    if (window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.invoke) {

      window.WebViewJavascriptBridge.invoke(funName, function (res) {
        var _res$data = res.data,
            data = _res$data === undefined ? {} : _res$data;

        callback(data);
      }, parameter);
    }
  }
};

var aliApiSafeRun = function aliApiSafeRun(task) {
  if (navigator.userAgent.indexOf('AlipayClient') > -1) task();else window.location.href = 'https://d.blibee.com/app_download/?r=blibee%3A%2F%2Freact%2Fbiz%3FprojectId%3Dblibee-app';
};

var bridgeInvoke = function bridgeInvoke(funName) {
  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return params;
  };
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.invoke) {
    window.WebViewJavascriptBridge.invoke(funName, function (res) {
      var _res$data2 = res.data,
          data = _res$data2 === undefined ? {} : _res$data2;

      cb(data);
    }, params);
  }
};

var bridgeVerCheck = function bridgeVerCheck(pkgVersion, bridgeName) {
  var support = false;
  if (SUPPORT_MAP[bridgeName]) {
    var min = SUPPORT_MAP[bridgeName].min;
    var max = SUPPORT_MAP[bridgeName].max;

    if (min !== undefined) {
      support = +pkgVersion >= +min;
    }

    if (support && max !== undefined) {
      support = +pkgVersion <= +max;
    }
    if (!support) {}
  } else {}
  return support;
};

var wxRedirectTo = function wxRedirectTo(params) {
  if (window.__wxjs_environment !== 'miniprogram') {
    window.location.href = 'https://d.blibee.com/app_download/?r=blibee%3A%2F%2Freact%2Fbiz%3FprojectId%3Dblibee-app';
  } else {
    wx.miniProgram.redirectTo({
      url: params.url
    });
  }
};

var aliRedirectTo = function aliRedirectTo(params) {
  aliApiSafeRun(function () {
    window.my.redirectTo({
      url: params.url
    });
  });
};

var wxNavigateTo = function wxNavigateTo(params) {
  if (window.__wxjs_environment !== 'miniprogram') {
    window.location.href = 'https://d.blibee.com/app_download/?r=blibee%3A%2F%2Freact%2Fbiz%3FprojectId%3Dblibee-app';
  } else {
    wx.miniProgram.navigateTo({
      url: params.url
    });
  }
};

var aliNavigateTo = function aliNavigateTo(params) {
  aliApiSafeRun(function () {
    window.my.navigateTo({
      url: params.url
    });
  });
};

var wxNavigateBack = function wxNavigateBack() {
  var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  if (window.__wxjs_environment !== 'miniprogram') {
    window.location.href = 'https://d.blibee.com/app_download/?r=blibee%3A%2F%2Freact%2Fbiz%3FprojectId%3Dblibee-app';
  } else {
    wx.miniProgram.navigateBack(step);
  }
};

var aliNavigateBack = function aliNavigateBack() {
  var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  aliApiSafeRun(function () {
    window.my.navigateBack(step);
  });
};

var wxPostMessage = function wxPostMessage(data) {
  if (window.__wxjs_environment !== 'miniprogram') {
    window.location.href = 'https://d.blibee.com/app_download/?r=blibee%3A%2F%2Freact%2Fbiz%3FprojectId%3Dblibee-app';
  } else {
    wx.miniProgram.postMessage({
      data: data
    });
  }
};

var aliPostMessage = function aliPostMessage(data) {
  aliApiSafeRun(function () {
    var my = window.my;
    my.postMessage({
      data: data
    });
  });
};

var wxGetLocation = function wxGetLocation(cb) {
  var failFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  if (window.__wxjs_environment !== 'miniprogram') {
    window.location.href = 'https://d.blibee.com/app_download/?r=blibee%3A%2F%2Freact%2Fbiz%3FprojectId%3Dblibee-app';
  } else {
    alert(wx.miniProgram.postMessage);
    wx.miniProgram.getLocation({
      type: 'gcj02',
      success: function success() {
        if (typeof cb === 'function') cb(res);
      },

      fail: failFunc
    });
  }
};

var wxShare = function wxShare(wxConfig, canShare, params) {
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    title: '',
    desc: '',
    imgUrl: '',
    link: window.location.href
  };
  var onSuccess = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return param;
  };
  var onCancel = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return param;
  };
  var callBack = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function () {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return param;
  };

  wx.config({
    debug: false,
    appId: wxConfig.appid,
    timestamp: wxConfig.timestamp,
    nonceStr: wxConfig.noncestr,
    signature: wxConfig.signature,
    jsApiList: ['hideMenuItems', 'showMenuItems', 'onMenuShareTimeline', 'onMenuShareAppMessage']
  });

  wx.error(function () {
    callBack();
  });

  wx.ready(function () {
    if (!canShare) {
      wx.hideMenuItems({
        menuList: ['menuItem:share:qq', 'menuItem:share:QZone', 'menuItem:share:appMessage', 'menuItem:share:timeline'] });
    } else {
      wx.showMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'] });
      wx.hideMenuItems({
        menuList: ['menuItem:share:qq', 'menuItem:share:QZone'] });

      wx.onMenuShareTimeline(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
        link: data.link + '?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, { source: 'moments' })),
        success: function success() {
          onSuccess('moments');
        },
        cancel: function cancel() {
          onCancel('moments');
        }
      }));

      wx.onMenuShareAppMessage(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
        link: data.link + '?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, { source: 'friends' })),
        success: function success() {
          onSuccess('friends');
        },
        cancel: function cancel() {
          onCancel('friends');
        }
      }));
    }
    callBack();
  });
};


/* harmony default export */ __webpack_exports__["a"] = (Bridge);

/***/ }),

/***/ 100:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "vux-label-desc"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-flexbox",
    class: {
      'vux-flex-col': _vm.orient === 'vertical',
        'vux-flex-row': _vm.orient === 'horizontal'
    },
    style: (_vm.styles)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": ("vux-popup-animate-" + _vm.position)
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && !_vm.initialShow),
      expression: "show && !initialShow"
    }],
    staticClass: "vux-popup-dialog",
    class: [("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],
    style: (_vm.styles)
  }, [(_vm.shouldRenderBody) ? _vm._t("default") : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-flexbox-item",
    style: (_vm.style)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return env; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var Env = function () {
  function Env() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Env);

    this.options = options;
    this.init();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Env, [{
    key: 'init',
    value: function init() {
      this.initData();
      this.register();
    }
  }, {
    key: 'initData',
    value: function initData() {
      this.envNames = [];

      this.registerEnv = [];

      this.registerInstance = {};

      this.defineData();
    }
  }, {
    key: 'defineData',
    value: function defineData() {
      var that = this;

      Object.defineProperty(this, 'name', {
        get: function get() {
          return that.getEnvName();
        }
      });

      Object.defineProperty(this, 'allName', {
        get: function get() {
          return that.getEnvName('ALL');
        }
      });

      Object.defineProperty(this, 'instance', {
        get: function get() {
          return that.registerInstance[that.getEnvName()];
        }
      });

      Object.defineProperty(this, 'phoneSys', {
        get: function get() {
          return Env.getPhoneSys();
        }
      });

      Object.defineProperty(this, 'wsPid', {
        get: function get() {
          return that.getWsPid();
        }
      });
    }
  }, {
    key: 'dynamicRegister',
    value: function dynamicRegister(EnvClass) {
      var envName = EnvClass.envName();
      if (!(this.registerInstance[envName] instanceof EnvClass)) {
        this.registerInstance[envName] = new EnvClass(this, {});
      }
    }
  }, {
    key: 'register',
    value: function register() {
      var _this = this;

      this.registerEnv.forEach(function (EnvClass) {
        var envName = EnvClass.envName();
        if (!(_this.registerInstance[envName] instanceof EnvClass)) {
          _this.registerInstance[envName] = new EnvClass(_this, {});
        }
      });
    }
  }, {
    key: 'getEnvName',
    value: function getEnvName() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (type === 'ALL') return this.envNames;

      return this.envNames[0];
    }
  }, {
    key: 'setEnvName',
    value: function setEnvName() {
      var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (env === 'wx') {
        if (this.envNames[0] !== 'mini') this.envNames.push(env);
      } else {
        this.envNames.push(env);
      }
    }
  }, {
    key: 'invoke',
    value: function invoke() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Env.isFunc(this.instance.invoke)) this.instance.invoke(opt);
    }
  }, {
    key: 'redirectTo',
    value: function redirectTo() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Env.isFunc(this.instance.redirectTo)) this.instance.redirectTo(opt);
    }
  }, {
    key: 'navigateTo',
    value: function navigateTo() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Env.isFunc(this.instance.navigateTo)) this.instance.navigateTo(opt);
    }
  }, {
    key: 'navigateBack',
    value: function navigateBack() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Env.isFunc(this.instance.navigateBack)) this.instance.navigateBack(opt);
    }
  }, {
    key: 'postMessages',
    value: function postMessages() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Env.isFunc(this.instance.postMessages)) this.instance.postMessages(opt);
    }
  }, {
    key: 'share',
    value: function share() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Env.isFunc(this.instance.share)) return this.instance.share(opt);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject();
    }
  }, {
    key: 'login',
    value: function login() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Env.isFunc(this.instance.login)) return this.instance.login(opt);
      return true;
    }
  }, {
    key: 'getWsPid',
    value: function getWsPid() {
      if (!this.instance) return '';
      if (Env.isFunc(this.instance.getWsPid)) return this.instance.getWsPid();
      return '';
    }
  }, {
    key: 'closeWindow',
    value: function closeWindow(opt) {
      if (Env.isFunc(this.instance.closeWindow)) this.instance.closeWindow(opt);
    }
  }], [{
    key: 'getPhoneSys',
    value: function getPhoneSys() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isAndroid) return 'android';
      if (isiOS) return 'ios';
      return 'others';
    }
  }, {
    key: 'isFunc',
    value: function isFunc(func) {
      return typeof func === 'function';
    }
  }]);

  return Env;
}();

var envInstance = null;

var env = function () {
  if (!(envInstance instanceof Env)) envInstance = new Env();
  return envInstance;
}();

/* harmony default export */ __webpack_exports__["b"] = ({
  install: function install(Vue) {
    Object.defineProperty(Vue.prototype, '$env', {
      value: env
    });
  }
});

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(125)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(130),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(124)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(129),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1131:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(126)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(131),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline_desc__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__props__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_clean_style__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_get_parent_prop__ = __webpack_require__(176);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cell',
  components: {
    InlineDesc: __WEBPACK_IMPORTED_MODULE_0__inline_desc___default.a
  },
  props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__props__["a" /* default */])(),
  created: function created() {
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;

    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__libs_clean_style__["a" /* default */])({
        width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__libs_get_parent_prop__["a" /* default */])(this, 'labelWidth'),
        textAlign: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__libs_get_parent_prop__["a" /* default */])(this, 'labelAlign'),
        marginRight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__libs_get_parent_prop__["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_router__["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_clean_style__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'group',
  methods: {
    cleanStyle: __WEBPACK_IMPORTED_MODULE_0__libs_clean_style__["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});

/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scroller__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flexbox__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chain__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filters_value2name__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_is_array__ = __webpack_require__(177);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'picker',
  components: {
    Flexbox: __WEBPACK_IMPORTED_MODULE_3__flexbox__["a" /* Flexbox */],
    FlexboxItem: __WEBPACK_IMPORTED_MODULE_3__flexbox__["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new __WEBPACK_IMPORTED_MODULE_4__chain__["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__filters_value2name__["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;

      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new __WEBPACK_IMPORTED_MODULE_2__scroller__["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);

      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new __WEBPACK_IMPORTED_MODULE_2__scroller__["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });

      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);

      if (this.columns !== 0) {
        if (val.length > 0) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);

          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.getValue()) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new __WEBPACK_IMPORTED_MODULE_4__chain__["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});

/***/ }),

/***/ 1195:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1203:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1223:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1236:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 126:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner.png";

/***/ }),

/***/ 1286:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/discount-detail.png";

/***/ }),

/***/ 1287:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/discount.png";

/***/ }),

/***/ 1288:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_1.png";

/***/ }),

/***/ 1289:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_2.png";

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.title) ? _c('div', {
    staticClass: "weui-cells__title",
    style: (_vm.cleanStyle({
      color: _vm.titleColor
    })),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("title"), _vm._v(" "), _c('div', {
    staticClass: "weui-cells",
    class: {
      'vux-no-group-title': !_vm.title
    },
    style: (_vm.cleanStyle({
      marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
    }))
  }, [_vm._t("after-title"), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.footerTitle) ? _c('div', {
    staticClass: "weui-cells__title vux-group-footer-title",
    style: (_vm.cleanStyle({
      color: _vm.footerTitleColor
    })),
    domProps: {
      "innerHTML": _vm._s(_vm.footerTitle)
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1290:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_3.png";

/***/ }),

/***/ 1291:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_4.png";

/***/ }),

/***/ 1292:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_5.jpg";

/***/ }),

/***/ 1293:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pending.png";

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell",
    class: {
      'vux-tap-active': _vm.isLink || !!_vm.link,
        'weui-cell_access': _vm.isLink || !!_vm.link,
        'vux-cell-no-border-intent': !_vm.borderIntent,
        'vux-cell-disabled': _vm.disabled
    },
    style: (_vm.style),
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
    staticClass: "vux-cell-bd",
    class: {
      'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'
    }
  }, [_c('p', [(_vm.title || _vm.hasTitleSlot) ? _c('label', {
    staticClass: "vux-label",
    class: _vm.labelClass,
    style: (_vm.labelStyles)
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2) : _vm._e(), _vm._v(" "), _vm._t("after-title")], 2), _vm._v(" "), _c('inline-desc', [_vm._t("inline-desc", [_vm._v(_vm._s(_vm.inlineDesc))])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft",
    class: _vm.valueClass
  }, [_vm._t("value"), _vm._v(" "), _vm._t("default", [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), (_vm.isLoading) ? _c('i', {
    staticClass: "weui-loading"
  }) : _vm._e()], 2), _vm._v(" "), _vm._t("child")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-picker"
  }, [_c('flexbox', {
    attrs: {
      "gutter": 0
    }
  }, _vm._l((_vm.currentData), function(one, index) {
    return _c('flexbox-item', {
      key: index,
      staticStyle: {
        "margin-left": "0"
      },
      attrs: {
        "span": _vm.columnWidth && _vm.columnWidth[index]
      }
    }, [_c('div', {
      staticClass: "vux-picker-item",
      attrs: {
        "id": ("vux-picker-" + _vm.uuid + "-" + index)
      }
    })])
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(8);









var Ax = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */],
  timeout: 1024000,
  withCredentials: true
});

Ax.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  var response = error.response;
  if (response.status === 401) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject('login failed');
  }
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

var myPromise = {
  then: function then() {
    return myPromise;
  },
  catch: function _catch() {
    return myPromise;
  }
};

var Request = {
  form: function form(url) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = arguments[2];

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Ax(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        url: url,
        method: 'post',
        data: __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(data)
      }, config)).then(function (res) {
        resolve(res.data);
      }).catch(function (err) {
        var msg = err.message || '接口错误';
        reject(msg);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Request);

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  share: {
    title: '分享就送优惠券，申请货架更有200元充值大礼哦～',
    desc: '便利蜂无人货架“蜂”狂来袭办公室，零食饮料、鲜食水果，触手可及',
    imageUrl: location.origin + '/jack/static/img/minishare-logo.png',
    imageWxUrl: 'https://s.blibee.net/res/blibee-app/image/shelves/share-logo.png',
    linkUrl: location.origin + '/jack/pages/application/index.html'
  }
});

/***/ }),

/***/ 1441:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoading) ? _c('section', {
    staticClass: "app-contanier"
  }, [_c('header-bar', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "onLeftAction": _vm.onBackEvent
    }
  }), _vm._v(" "), (_vm.isOver) ? _c('section', {
    staticClass: "over-panel"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("更多精彩，敬请期待~")])]) : _vm._e(), _vm._v(" "), (!_vm.isOver) ? _c('section', {
    staticClass: "content-panel",
    attrs: {
      "id": "contentPanel"
    }
  }, [_c('section', {
    staticClass: "title-container"
  }, [_c('div', {
    staticClass: "success-title"
  }, [_vm._v(_vm._s(_vm.successTitle))]), _vm._v(" "), (_vm.successDes) ? _c('div', {
    staticClass: "success-des"
  }, [_vm._v(_vm._s(_vm.successDes))]) : _vm._e()]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (!_vm.token && !_vm.isOver) ? _c('footer', {
    staticClass: "footer-container",
    on: {
      "click": function($event) {
        _vm.onStopPropagation($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-item vux-1px"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephone),
      expression: "telephone"
    }],
    staticClass: "form-input",
    attrs: {
      "id": "phone",
      "autocomplete": "off",
      "type": "tel",
      "placeholder": "请输入手机号",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telephone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-item vux-1px",
    staticStyle: {
      "margin-top": "10px"
    },
    on: {
      "click": function($event) {
        _vm.onStopPropagation($event)
      }
    }
  }, [_c('div', {
    staticClass: "right-r"
  }, [(!_vm.isSendCode) ? _c('div', {
    staticClass: "plain-btn",
    attrs: {
      "for": "code"
    },
    on: {
      "click": _vm.fetchVerificationCode
    }
  }, [_vm._v("获取验证码")]) : _c('div', {
    staticClass: "plain-btn"
  }, [_vm._v(_vm._s(_vm.seconds) + "s后重试")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verificationCode),
      expression: "verificationCode"
    }],
    ref: "verCode",
    staticClass: "form-input code-input",
    attrs: {
      "id": "code",
      "type": "number",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.verificationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verificationCode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.onGet
    }
  }, [_vm._v("领取")])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": __webpack_require__(1293),
      "width": "110"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "discount-container"
  }, [_c('img', {
    staticClass: "discount-img",
    attrs: {
      "src": __webpack_require__(1287),
      "title": "优惠券"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "discount-img detail",
    attrs: {
      "src": __webpack_require__(1286),
      "title": "优惠券使用说明"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("手机号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "autocomplete": "off",
      "for": "code"
    }
  }, [_vm._v("验证码")])])
}]}

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Cookie__ = __webpack_require__(9);




var Device = {
  getId: function getId(key) {
    var cookieName = key || 'deviceid';
    var token = __WEBPACK_IMPORTED_MODULE_0__utils_Cookie__["a" /* default */].get(cookieName);
    if (!token) {
      var date = +new Date();
      var random = '' + Math.random();
      token = 'h5_' + date + random.replace(/\./, '');
    }
    return token;
  },
  getCacheId: function getCacheId(key) {
    var cookieName = key || 'deviceId';
    var deviceId = window.localStorage.getItem(cookieName);
    if (!deviceId) {
      var date = +new Date();
      var random = '' + Math.random();
      deviceId = 'h5_' + date + random.replace(/\./, '');
      window.localStorage.setItem(cookieName, deviceId);
    }
    return deviceId;
  },
  getDeviceId: function getDeviceId() {
    var date = +new Date();
    var random = '' + Math.random();
    var token = 'h5_' + date + random.replace(/\./, '');
    return token;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Device);

/***/ }),

/***/ 1510:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-contanier"
  }, [_c('header-bar', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "onLeftAction": _vm.onBackEvent
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-panel"
  }, [_vm._m(0), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "form-item vux-1px-b",
    on: {
      "click": _vm.onOpenAddress
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cityNameStr),
      expression: "cityNameStr"
    }],
    staticClass: "form-input code-input",
    attrs: {
      "readonly": "",
      "id": "cityInput",
      "type": "text",
      "placeholder": "请选择所在城市"
    },
    domProps: {
      "value": (_vm.cityNameStr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cityNameStr = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "form-item vux-1px-b"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }],
    staticClass: "form-input code-input",
    attrs: {
      "id": "nameInput",
      "type": "text",
      "maxlength": "50",
      "placeholder": "请输入公司名称"
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-item vux-1px-b",
    on: {
      "click": _vm.onClickCount
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countText),
      expression: "countText"
    }],
    staticClass: "form-input code-input",
    attrs: {
      "readonly": "",
      "id": "cityInput",
      "type": "text",
      "placeholder": "请选择公司常驻人数"
    },
    domProps: {
      "value": (_vm.countText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.countText = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "form-item vux-1px-b"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactName),
      expression: "contactName"
    }],
    staticClass: "form-input code-input",
    attrs: {
      "id": "userNameInput",
      "type": "text",
      "maxlength": "50",
      "placeholder": "请输入联系人姓名"
    },
    domProps: {
      "value": (_vm.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-item vux-1px-b"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactPhone),
      expression: "contactPhone"
    }],
    staticClass: "form-input code-input",
    attrs: {
      "id": "phoneInput",
      "maxlength": "11",
      "type": "tel",
      "placeholder": "请输入联系人手机号"
    },
    domProps: {
      "value": (_vm.contactPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactPhone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "form-item vux-1px-b"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verificationCode),
      expression: "verificationCode"
    }],
    ref: "verCode",
    staticClass: "form-input code-input",
    attrs: {
      "id": "code",
      "type": "number",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.verificationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verificationCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-r"
  }, [(!_vm.isSendCode) ? _c('div', {
    staticClass: "plain-btn",
    attrs: {
      "for": "code"
    },
    on: {
      "click": _vm.fetchVerificationCode
    }
  }, [_vm._v("获取验证码")]) : _c('div', {
    staticClass: "plain-btn"
  }, [_vm._v(_vm._s(_vm.seconds) + "s后重试")])])])])]), _vm._v(" "), _c('popup', {
    staticClass: "vux-popup left-popup",
    attrs: {
      "position": 'bottom',
      "hideOnBlur": true
    },
    model: {
      value: (_vm.isShowAddreddPanel),
      callback: function($$v) {
        _vm.isShowAddreddPanel = $$v
      },
      expression: "isShowAddreddPanel"
    }
  }, [_c('address-select', {
    ref: "addressPanel",
    attrs: {
      "default-province": _vm.provinceId,
      "default-city": _vm.cityId,
      "level": 1
    },
    on: {
      "onCloseAddress": _vm.onCloseAddress
    }
  })], 1), _vm._v(" "), _c('popup', {
    staticClass: "vux-popup center-popup",
    attrs: {
      "position": 'bottom',
      "hideOnBlur": true
    },
    model: {
      value: (_vm.isShowCountPop),
      callback: function($$v) {
        _vm.isShowCountPop = $$v
      },
      expression: "isShowCountPop"
    }
  }, [_c('header', {
    staticClass: "popup-header coutn-popup-header vux-1px-b"
  }, [_c('div', {
    staticClass: "popup-btn cancel"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-title"
  }, [_vm._v("公司常驻人数")]), _vm._v(" "), _c('div', {
    staticClass: "popup-btn sure",
    on: {
      "click": _vm.onCloseCount
    }
  }, [_c('i', {
    staticClass: "close-icon icon iconfont"
  }, [_vm._v("")])])]), _vm._v(" "), _c('picker', {
    ref: "countPicker",
    attrs: {
      "title": '公司常驻人数',
      "popup-title": '公司常驻人数',
      "placeholder": '请选择公司常驻人数(50人以上)',
      "data": _vm.countList,
      "show-name": true
    },
    on: {
      "on-change": _vm.onChangeCount
    },
    model: {
      value: (_vm.peopleCount),
      callback: function($$v) {
        _vm.peopleCount = $$v
      },
      expression: "peopleCount"
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "footer-panel"
  }, [_c('div', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交申请")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": __webpack_require__(1285),
      "title": "入驻成功¥200充值奖励"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "autocomplete": "off",
      "for": "cityInput"
    }
  }, [_vm._v("所在城市")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-r"
  }, [_c('i', {
    staticClass: "arrow icon iconfont"
  }, [_vm._v("")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "autocomplete": "off",
      "for": "nameInput"
    }
  }, [_vm._v("公司名称")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "autocomplete": "off",
      "for": "cityInput"
    }
  }, [_vm._v("公司常驻人数")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-r"
  }, [_c('i', {
    staticClass: "arrow icon iconfont"
  }, [_vm._v("")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "autocomplete": "off",
      "for": "userNameInput"
    }
  }, [_vm._v("联系人姓名")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "autocomplete": "off",
      "for": "phoneInput"
    }
  }, [_vm._v("联系人手机号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-item vux-1px-b des"
  }, [_c('span', {
    staticClass: "ps-des"
  }, [_vm._v("注：200元充值奖励将发放至此手机号账户")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "autocomplete": "off",
      "for": "code"
    }
  }, [_vm._v("验证码")])])
}]}

/***/ }),

/***/ 1518:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-contanier"
  }, [_c('header-bar', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "onLeftAction": _vm.onBack
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-panel"
  }, [_c('section', {
    staticClass: "des-panel"
  }, [_c('i', {
    staticClass: "success-icon iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('p', {
    staticClass: "success-text"
  }, [_vm._v("提交成功")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v("感谢您的申请，工作人员将会尽快与您联系")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v("成功入驻后，200元充值奖励将在5个工作日内")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v("发放到您的便利蜂账户 " + _vm._s(_vm.userPhone))])]), _vm._v(" "), _c('section', {
    staticClass: "btn",
    on: {
      "click": _vm.onGoHome
    }
  }, [_vm._v("完成")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1539:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-contanier"
  }, [_c('header-bar', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "onLeftAction": _vm.onBackEvent,
      "onRightAction": _vm.onShareEvent
    }
  }, [_c('i', {
    staticClass: "icon iconfont",
    attrs: {
      "slot": "rightBtn"
    },
    slot: "rightBtn"
  }, [_vm._v("")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('footer', {
    staticClass: "footer-panel"
  }, [_c('div', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.onGotoSubmit
    }
  }, [_vm._v("立即申请")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-panel"
  }, [_c('section', [_c('img', {
    staticClass: "content-des",
    attrs: {
      "src": __webpack_require__(1288)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "content-des",
    attrs: {
      "src": __webpack_require__(1289)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "content-des",
    attrs: {
      "src": __webpack_require__(1290)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "content-des",
    attrs: {
      "src": __webpack_require__(1291)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "content-des",
    attrs: {
      "src": __webpack_require__(1292)
    }
  })])])
}]}

/***/ }),

/***/ 1552:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isAndroid) ? _c('section', {
    staticClass: "app-wrapper",
    style: ({
      height: _vm.screenHeight
    }),
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1) : _c('section', {
    staticClass: "app-wrapper",
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1579:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1223)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(902),
  /* template */
  __webpack_require__(1539),
  /* scopeId */
  "data-v-7b013dea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1580:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1131)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(903),
  /* template */
  __webpack_require__(1441),
  /* scopeId */
  "data-v-1ce6880e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1581:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1195)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(904),
  /* template */
  __webpack_require__(1510),
  /* scopeId */
  "data-v-5f57217c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1582:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1203)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(905),
  /* template */
  __webpack_require__(1518),
  /* scopeId */
  "data-v-68cc6592",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function getSource() {
  var ua = window.navigator.userAgent.toLowerCase();
  var source = '';
  if (/micromessenger/i.test(ua)) {
    source = 'wx_app';
  } else {
    source = 'app';
  }
  return source;
}

function getStorageItem(key) {
  return localStorage.getItem(key);
}

function setStorageItem(key, value) {
  window.localStorage.setItem(key, value);
}

function getCookieItem(key) {
  var cookieData = document.cookie;
  if (cookieData.length > 0) {
    var startData = cookieData.indexOf(key + '=');
    if (startData !== -1) {
      startData = startData + key.length + 1;
      var endData = cookieData.indexOf(';', startData);
      if (endData === -1) {
        endData = cookieData.length;
      }
      return unescape(cookieData.substring(startData, endData));
    }
  }
  return '';
}

var expiredays = 365;

function setCookieItem(key, value) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = key + '=' + escape(value) + (expiredays === null ? '' : ';expires=' + exdate.toUTCString());
}

var source = getSource();

var LocalStorage = {
  set: function set(key, value) {
    if (source === 'wx_app') {
      setCookieItem(key, value);
    } else {
      setStorageItem(key, value);
    }
  },
  get: function get(key) {
    if (source === 'wx_app') {
      return getCookieItem(key);
    }
    return getStorageItem(key);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (LocalStorage);

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var IS_PROD = "production" === 'production';

var url = IS_PROD ? 'https://stat.blibee.com' : 'http://stat.beta.wormpex.com';

var config = {
  uri: url + '/app/log'
};

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getPhoneSys = function getPhoneSys() {
  var u = window.navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (isAndroid) return 'android';
  if (isiOS) return 'ios';
  return 'others';
};

/* harmony default export */ __webpack_exports__["a"] = ({ getPhoneSys: getPhoneSys });

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__env__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Request__ = __webpack_require__(6);









function Image(id) {
  var imageID = '#' + (id || 'log_image_id');
  var image = document.getElementById(imageID);
  if (image) return image;

  image = document.createElement('img');
  image.setAttribute('id', imageID);
  image.setAttribute('style', 'width: 1px; height: 1px;visibility: hidden; position: absolute; left: -99999px;bottom: 0;');
  document.body.appendChild(image);

  setTimeout(function () {
    document.body.removeChild(image);
  }, 200);

  return image;
}

function stringify(json) {
  var detail = '{';
  var i = 0;
  for (var x in json) {
    if (json[x]) {
      var gap = i > 0 ? ',' : '';
      detail += gap + '"' + x + '":"' + json[x] + '"';
      i++;
    }
  }
  detail += '}';
  return detail;
}


var logCommonInfo = {
  project_id: 'fe_customer_jack_h5',
  pid: (__WEBPACK_IMPORTED_MODULE_3__env__["a" /* default */].getPhoneSys() === 'ios' ? '6' : '8') + '0142'
};

function _Log(key, detail, others) {
  var image = Image(new Date().getTime());
  var headersInfo = __WEBPACK_IMPORTED_MODULE_5__Request__["a" /* default */].getHeader() || {};

  var params = {
    pid: logCommonInfo.pid,
    entry_key: key,
    entry_detail: detail,
    common: logCommonInfo,
    client_time: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["e" /* formatTime */])(),
    headers: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(headersInfo)
  };

  if (others) {
    params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, others);
  }
  params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(params);

  var uri = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].uri + '?data=' + params;
  console.log(uri);
  image.setAttribute('src', encodeURI(uri));
}

function Log(project_id) {
  logCommonInfo.project_id = project_id;
  return _Log;
}
/* harmony default export */ __webpack_exports__["a"] = (Log);

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Random = {
  get: function get() {
    var thisDate = new Date('2017-11-03'.replace(/-/g, '/'));
    var thatDate = new Date();
    var millisecond = thatDate.getTime() - thisDate.getTime();
    var diffDay = parseInt((millisecond < 0 ? 0 : millisecond) / (1000 * 60 * 60 * 24), 10);

    return 100 + diffDay * 45;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Random);

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_plugins_wechat_index_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Invitation_assets_logo_png__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Invitation_assets_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Invitation_assets_logo_png__);









__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vux_src_plugins_wechat_index_js__["a" /* default */]);

var wx = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].wechat;

var isWechat = function isWechat() {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  }

  return false;
};

var jsApiList = ['updateAppMessageShareData', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'getLocation', 'closeWindow'];

var getAppId = function getAppId() {
  if (!isWechat()) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {});
  }
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* Request */].post('/usercenter/weixinmp/jsapi/v1', {
      url: window.location.href.split('#')[0]
    }).then(function (res) {
      if (res.ret && res.data) {
        resolve(res.data);
      } else {
        reject(res.data);
      }
    });
  });
};

var wxLogin = function wxLogin(redirectUrl, param, apiScope) {
  try {
    var wxBaselink = 'https://open.weixin.qq.com/connect/oauth2/authorize';
    var deviceId = __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* Device */].getDeviceId();
    var urlPrefix = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* IS_PROD */] ? 'https://api.bianlifeng.com' : 'http://b1.api.wormpex.com';
    var finalUrl = encodeURIComponent(urlPrefix + '/usercenter/weixinmp/login/v1?deviceid=' + deviceId + '&redirectUrl=' + encodeURIComponent(redirectUrl) + '&param=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param || {}));

    var appid = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* IS_PROD */] ? 'wxddfa9205e94a24db' : 'wx188265647466d243';
    var redirect_uri = finalUrl;
    var response_type = 'code';
    var scope = apiScope || 'snsapi_base';
    var wxLoginLink = wxBaselink + '?appid=' + appid + '&redirect_uri=' + redirect_uri + '&response_type=' + response_type + '&scope=' + scope;
    return wxLoginLink;
  } catch (error) {
    console.log(error);
  }
};

var newLogin = function newLogin(redirectUrl, param, apiScope) {
  try {
    var wxBaselink = 'https://open.weixin.qq.com/connect/oauth2/authorize';
    var deviceId = __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* Device */].getCacheId();
    var urlPrefix = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* IS_PROD */] ? 'https://api.bianlifeng.com' : 'http://wormpex.com';
    var finalUrl = encodeURIComponent(urlPrefix + '/usercenter/weixinmp/login/v1?deviceid=' + deviceId + '&redirectUrl=' + encodeURIComponent(redirectUrl) + '&param=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(param || {}));

    var appid = __WEBPACK_IMPORTED_MODULE_3__utils__["d" /* IS_PROD */] ? 'wxddfa9205e94a24db' : 'wx188265647466d243';
    var redirect_uri = finalUrl;
    var response_type = 'code';
    var scope = apiScope || 'snsapi_base';
    return wxBaselink + '?appid=' + appid + '&redirect_uri=' + redirect_uri + '&response_type=' + response_type + '&scope=' + scope + '#wechat_redirect';
  } catch (error) {
    console.log(error);
  }
};

var share = function share(data) {
  wx.config({
    debug: false,
    appId: data.appid,
    timestamp: data.timestamp,
    nonceStr: data.noncestr,
    signature: data.signature,
    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'scanQRCode', 'getLocation', 'closeWindow']
  });
  wx.ready(function () {
    var title = data.title || '便利蜂无人值守货架，承包你的一日三餐！';
    var desc = data.desc || '办公室必备，尽享便利，小小幸福在你身边';
    var link = data.link || location.origin + '/jack/pages/invitation/';
    var imgUrl = data.imgUrl || location.origin + '/jack/static/img/logo.png';
    var onSuccess = data.onSuccess || function () {};
    var onCancel = data.onCancel || function () {};

    wx.onMenuShareTimeline({
      title: title,
      link: link,
      imgUrl: imgUrl,
      success: function success() {

        onSuccess({
          status: 'success',
          channel: 'weixin_circle'
        });
      },
      cancel: function cancel() {

        onCancel();
      }
    });

    wx.onMenuShareAppMessage({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: function success() {
        onSuccess({
          status: 'success',
          channel: 'weixin'
        });
      },
      cancel: function cancel() {
        onCancel();
      }
    });

    wx.onMenuShareQQ({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: function success() {

        onSuccess({
          status: 'success',
          channel: 'qq'
        });
      },
      cancel: function cancel() {

        onCancel();
      }
    });

    wx.onMenuShareQZone({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: function success() {

        onSuccess({
          status: 'success',
          channel: 'qzone'
        });
      },
      cancel: function cancel() {

        onCancel();
      }
    });
  });
};

var newShare = function newShare(data) {
  getAppId().then(function (config) {
    window.wx.config({
      debug: false,
      appId: config.appid,
      timestamp: config.timestamp,
      nonceStr: config.noncestr,
      signature: config.signature,
      jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'scanQRCode', 'getLocation', 'closeWindow']
    });
    window.wx.ready(function () {
      var title = data.title || '便利蜂无人值守货架，承包你的一日三餐！';
      var desc = data.desc || '办公室必备，尽享便利，小小幸福在你身边';
      var link = data.link || location.origin + '/jack/pages/invitation/';
      var imgUrl = data.imgUrl || location.origin + '/jack/static/img/logo.png';
      var onSuccess = data.onSuccess || function () {};
      var onCancel = data.onCancel || function () {};

      window.wx.onMenuShareTimeline({
        title: title,
        link: link,
        imgUrl: imgUrl,
        success: function success() {

          onSuccess({
            status: 'success',
            channel: 'weixin_circle'
          });
        },
        cancel: function cancel() {

          onCancel();
        }
      });

      window.wx.onMenuShareAppMessage({
        title: title,
        desc: desc,
        link: link,
        imgUrl: imgUrl,
        success: function success() {
          onSuccess({
            status: 'success',
            channel: 'weixin'
          });
        },
        cancel: function cancel() {
          onCancel();
        }
      });

      window.wx.onMenuShareQQ({
        title: title,
        desc: desc,
        link: link,
        imgUrl: imgUrl,
        success: function success() {

          onSuccess({
            status: 'success',
            channel: 'qq'
          });
        },
        cancel: function cancel() {

          onCancel();
        }
      });

      window.wx.onMenuShareQZone({
        title: title,
        desc: desc,
        link: link,
        imgUrl: imgUrl,
        success: function success() {

          onSuccess({
            status: 'success',
            channel: 'qzone'
          });
        },
        cancel: function cancel() {

          onCancel();
        }
      });
    });
  });
};

var getGPS = function getGPS() {
  if (!isWechat()) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {});
  }
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    getAppId().then(function (configData) {
      window.wx.config({
        debug: false,
        appId: configData.appid,
        timestamp: configData.timestamp,
        nonceStr: configData.noncestr,
        signature: configData.signature,
        jsApiList: jsApiList
      });
      window.wx.ready(function () {
        window.wx.getLocation({
          type: 'gcj02', success: function success(res) {
            var latitude = res.latitude;
            var longitude = res.longitude;
            resolve({
              latitude: latitude, longitude: longitude
            });
          },
          fail: function fail() {
            reject();
          },
          cancel: function cancel() {
            reject();
          }
        });
      });
    }).catch(function (e) {
      console.log(e);
      reject(e);
    });
  });
};

var getLocation = function getLocation() {
  if (!isWechat()) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {});
  }
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    getAppId().then(function (configData) {
      wx.config({
        debug: false,
        appId: configData.appid,
        timestamp: configData.timestamp,
        nonceStr: configData.noncestr,
        signature: configData.signature,
        jsApiList: jsApiList
      });
      wx.ready(function () {
        wx.getLocation({
          type: 'gcj02', success: function success(res) {
            var latitude = res.latitude;
            var longitude = res.longitude;
            resolve({
              latitude: latitude, longitude: longitude
            });
          },
          fail: function fail(e) {
            reject(e);
          },
          cancel: function cancel() {
            reject();
          }
        });
      });
    }).catch(function (e) {
      console.log(e);
      reject(e);
    });
  });
};

var updateShare = function updateShare(config) {
  console.log('获取到图片updateShare');
  if (!isWechat() || !window.wx.updateAppMessageShareData) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {});
  }
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    getAppId().then(function (configData) {
      console.log('获取到图片 config');
      window.wx.config({
        debug: false,
        appId: configData.appid,
        timestamp: configData.timestamp,
        nonceStr: configData.noncestr,
        signature: configData.signature,
        jsApiList: jsApiList
      });
      window.wx.ready(function () {
        console.log('获取到图片 updateAppMessageShareData');
        window.wx.updateAppMessageShareData({
          title: config.title || '蜂拼团',
          desc: config.desc,
          link: config.link,
          imgUrl: config.imgUrl, success: function success(res) {
            resolve();
            console.log('分享成功');
          },
          fail: function fail() {
            reject();
            console.error('分享信息更新失败');
          },
          cancel: function cancel() {
            reject();
          }
        });
      });
    }).catch(function (e) {
      console.log(e);
      reject(e);
    });
  });
};

var hideAllNonBaseMenuItem = function hideAllNonBaseMenuItem(config) {
  if (!isWechat() || !window.wx.hideAllNonBaseMenuItem) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {});
  }
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    getAppId().then(function (configData) {
      window.wx.config({
        debug: false,
        appId: configData.appid,
        timestamp: configData.timestamp,
        nonceStr: configData.noncestr,
        signature: configData.signature,
        jsApiList: jsApiList
      });
      window.wx.ready(function () {
        window.wx.hideAllNonBaseMenuItem();
      });
    }).catch(function (e) {
      console.log(e);
      reject(e);
    });
  });
};

var showAllNonBaseMenuItem = function showAllNonBaseMenuItem() {
  if (!isWechat() || !window.wx.showAllNonBaseMenuItem) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {});
  }
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    getAppId().then(function (configData) {
      window.wx.config({
        debug: false,
        appId: configData.appid,
        timestamp: configData.timestamp,
        nonceStr: configData.noncestr,
        signature: configData.signature,
        jsApiList: jsApiList
      });
      window.wx.ready(function () {
        window.wx.showAllNonBaseMenuItem();
      });
    }).catch(function (e) {
      console.log(e);
      reject(e);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAppId: getAppId,
  share: share,
  isWechat: isWechat,
  wxLogin: wxLogin,
  getGPS: getGPS,
  getLocation: getLocation,
  updateShare: updateShare,
  newLogin: newLogin,
  newShare: newShare,
  hideAllNonBaseMenuItem: hideAllNonBaseMenuItem,
  showAllNonBaseMenuItem: showAllNonBaseMenuItem,
  jsApiList: jsApiList
});

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.png";

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  countList: ['请选择公司常驻人数', '50-100人', '100-200人', '200人以上']
});

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__ = __webpack_require__(65);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'toast',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-toast"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMask && _vm.show),
      expression: "isShowMask && show"
    }],
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.currentTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-toast",
    class: _vm.toastClass,
    style: ({
      width: _vm.width
    })
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'text'),
      expression: "type !== 'text'"
    }],
    staticClass: "weui-icon-success-no-circle weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style),
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style)
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AddressSelect__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AddressSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AddressSelect__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__AddressSelect___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Header__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Header___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderBanner__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__HeaderBanner__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__HeaderBanner___default.a; });




/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_param_object__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_param_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_url_param_object__);




var isAndroid = __WEBPACK_IMPORTED_MODULE_0_url_param_object___default.a.getParamValue('system') === 'android';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title', 'headerStyle', 'rightBtnStyle', 'leftBtnStyle'],
  data: function data() {
    return {
      isShowHeader: false,
      heigit: isAndroid ? 56 : 44
    };
  },


  computed: {
    navTitle: function navTitle() {
      if (!this.title) {
        return '无人货架';
      }
      return this.title;
    }
  },

  methods: {
    onLeftAction: function onLeftAction() {
      this.$emit('onLeftAction');
    },
    onRightAction: function onRightAction() {
      this.$emit('onRightAction');
    }
  },

  mounted: function mounted() {
    this.isShowHeader = this.$store.state.isShowHeader;
  }
});

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);





var defaultHeaderImg = 'https://s.blibee.net/res/blibee-app/image/takeout/takeawayBanner.jpg';
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['bannerParam', 'showBannerIndex', 'defaultHeaderImg'],
  data: function data() {
    return {
      bannerList: []
    };
  },


  computed: {
    headerImg: function headerImg() {
      if (this.showBannerIndex === '') return '';
      if (this.bannerList.length === 0) return '';
      return this.bannerList[this.showBannerIndex].imgUrl;
    }
  },

  mounted: function mounted() {
    var _this = this;

    var url = '/cvs/notify/app/banner/v4';
    var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      adLocations: [],
      cityCode: '',
      shopId: 0,
      shopCode: ''
    }, this.bannerParam);
    __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* Request */].post(url, params).then(function (res) {
      if (params.adLocations[0] && res.data[params.adLocations[0]]) {
        var bannerList = res.data[params.adLocations[0]].adItems || [];
        if (bannerList.length > 0) {
          _this.$emit('receiveParams', bannerList);
        }
        if (bannerList.length === 0) {
          bannerList.push({ imgUrl: _this.defaultHeaderImg || defaultHeaderImg });
        }
        _this.bannerList = bannerList;
      }
    }).catch(function () {});
  }
});

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);



var anTime = 150;
var apiUrl = '/crm/api/thirdparty/city/list/v1';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    defaultProvince: {
      type: String
    },
    defaultCity: {
      type: String
    },
    level: {
      type: Number
    }
  },
  data: function data() {
    return {
      $allCity: [],
      $allDistrict: [],

      bodyWidth: document.body.offsetWidth || 375,
      cityAn: 'move',
      provinceAn: 'miniMove',
      districtAn: 'move',

      isShowProvince: true,
      isShowCity: false,
      isShowDistrict: false,

      provinceId: this.defaultProvince || '',
      provinceName: '',

      cityId: this.defaultCity || '',
      cityName: '',

      districtId: this.defaultDistrictId || '',
      districtName: '',

      provinceList: [],
      cityList: [],
      districtList: []
    };
  },


  methods: {
    onCancel: function onCancel() {
      this.onClosePanel(4);
    },
    onClickTitle: function onClickTitle(type) {
      var _this = this;

      switch (type) {
        case 1:
          this.isShowCity = false;
          setTimeout(function () {
            _this.isShowProvince = true;
          }, anTime);
          this.isShowDistrict = false;
          break;
        case 2:
          if (this.isShowProvince) {
            this.cityAn = 'move';
          }
          if (this.isShowDistrict) {
            this.cityAn = 'miniMove';
          }
          this.isShowProvince = false;
          setTimeout(function () {
            _this.isShowCity = true;
          }, anTime);
          this.isShowDistrict = false;
          break;
        case 3:
          this.isShowProvince = false;
          this.isShowCity = false;
          setTimeout(function () {
            _this.isShowDistrict = true;
          }, anTime);
          break;
        default:
          break;
      }
    },
    onClickPanel: function onClickPanel(type, item) {
      var _this2 = this;

      switch (type) {
        case 1:
          this.provinceName = item.name;
          this.provinceId = item.code;
          this.cityId = '';
          this.cityName = '';
          this.cityAn = 'move';
          this.fetchCity(this.provinceId, function (data) {
            _this2.cityList = data.map(function (el) {
              return {
                code: el.regionCode,
                name: el.city
              };
            });
            _this2.setShowStatus();
            _this2.onClosePanel(type, item);
          });
          break;
        case 2:
          this.cityId = item.code;
          this.cityName = item.name;
          this.districtId = '';
          this.districtName = '';
          if (this.level > 2) {
            this.fetchDistrict(this.cityId, function (data) {
              _this2.districtList = data.map(function (el) {
                return {
                  code: el.regionCode,
                  name: el.district
                };
              });
              _this2.setShowStatus();
              _this2.onClosePanel(type, item);
            });
          } else {
            this.setShowStatus();
            this.onClosePanel(type, item);
          }
          break;
        case 3:
          this.districtId = item.code;
          this.districtName = item.name;
          this.onClosePanel(type, item);
          break;
        default:
          break;
      }
    },
    onChoseCity: function onChoseCity(type, item) {
      var resData = {};
      this.cityId = item.code;
      this.cityName = item.name;
      resData.cityId = item.code;
      resData.cityName = item.name;
      this.setShowStatus();
      this.$emit('onCloseAddress', resData);
    },
    setShowStatus: function setShowStatus(init) {
      var _this3 = this;

      if (this.showProvince()) {
        setTimeout(function () {
          _this3.isShowProvince = true;
        }, anTime);
      } else {
        this.isShowProvince = false;
      }
      if (this.showCity() && this.cityList.length > 0) {
        setTimeout(function () {
          _this3.isShowCity = true;
        }, anTime);
      } else {
        this.isShowCity = false;
      }
      if (this.showDistrict() && this.districtList.length > 0) {
        setTimeout(function () {
          _this3.isShowDistrict = true;
        }, anTime);
      } else {
        this.isShowDistrict = false;
      }
      if (init) {
        if (this.cityList.length === 0) {
          this.isShowCity = false;
          this.isShowProvince = true;
        }
      }
    },
    onClosePanel: function onClosePanel(type) {
      var resData = {
        type: type
      };
      switch (type) {
        case 1:
          if (this.level === 1 || this.cityList.length === 0) {
            resData.provinceId = this.provinceId;
            resData.provinceName = this.provinceName;
            this.$emit('onCloseAddress', resData);
          }
          break;
        case 2:
          if (this.level === 2) {
            resData.provinceId = this.provinceId;
            resData.provinceName = this.provinceName;
            resData.cityId = this.cityId;
            resData.cityName = this.cityName;
            this.$emit('onCloseAddress', resData);
          }
          break;
        case 3:
          if (this.level === 3) {
            resData.provinceId = this.provinceId;
            resData.provinceName = this.provinceName;
            resData.cityId = this.cityId;
            resData.cityName = this.cityName;
            resData.districtId = this.districtId;
            resData.districtName = this.districtName;
            this.$emit('onCloseAddress', resData);
          }
          break;
        default:
          this.$emit('onCloseAddress', resData);
          break;
      }
    },
    initData: function initData(pram) {
      var _this4 = this;

      var prams = pram || {};
      this.provinceId = prams.provinceId || '';
      this.provinceName = prams.provinceName || '';
      this.cityId = prams.cityId || '';
      this.cityName = prams.cityName || '';
      this.districtId = prams.districtId || '';
      this.districtName = prams.districtName || '';
      if (this.provinceName) {
        this.fetchCity(this.provinceId, function (data) {
          _this4.cityList = data.map(function (el) {
            return {
              code: el.regionCode,
              name: el.city
            };
          });
          _this4.setShowStatus(true);
        });
      } else {
        this.setShowStatus(true);
      }
    },
    initSelectData: function initSelectData(params, callback) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* Request */].get(apiUrl, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)).then(function (res) {
        if (res.status !== 0) {
          _this5.clearData(params.level, res.msg || '获取城市失败');
          return false;
        }
        var data = res.data || [];
        callback(data);
        return true;
      }).catch(function () {
        _this5.clearData(params.level, '获取城市失败');
      });
    },
    clearData: function clearData(level, msg) {
      this.$vux.toast.show({
        position: 'middle',
        type: 'text',
        text: msg,
        width: '16em'
      });
      if (level === 1) {
        this.provinceList = [];
        return;
      }

      if (level === 2) {
        this.cityList = [];
        return;
      }

      if (level === 3) {
        this.districtList = [];
      }
    },
    fetchProvice: function fetchProvice(callback) {
      this.initSelectData({
        level: 1
      }, callback);
    },
    fetchCity: function fetchCity(province, callback) {
      this.initSelectData({
        province: province,
        level: 2
      }, callback);
    },
    fetchDistrict: function fetchDistrict(city, callback) {
      this.initSelectData({
        city: city,
        level: 3
      }, callback);
    },
    showProvince: function showProvince() {
      if (this.provinceId && this.level > 1) {
        return false;
      }
      return true;
    },
    showCity: function showCity() {
      if (this.cityId && this.level > 2) {
        return false;
      }
      if (this.cityId) {
        return true;
      }
      if (this.isShowProvince) {
        return false;
      }
      return true;
    },
    showDistrict: function showDistrict() {
      if (this.isShowProvince || this.isShowCity) {
        return false;
      }

      if (this.cityId && this.level > 2) {
        return true;
      }
      return false;
    }
  },

  mounted: function mounted() {
    var _this6 = this;

    this.fetchProvice(function (data) {
      _this6.provinceList = data.map(function (item) {
        return {
          code: item.regionCode,
          name: item.city
        };
      });
      _this6.initData();
    });
  }
});

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "popup-panel",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('header', {
    staticClass: "popup-header address-popup-header vux-1px-b"
  }, [_c('section', {
    staticClass: "popup-header-title"
  }, [_c('div', {
    staticClass: "popup-btn cancel"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-title"
  }, [_vm._v("所在城市")]), _vm._v(" "), _c('div', {
    staticClass: "popup-btn close",
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "icon iconfont"
  }, [_vm._v("")])])]), _vm._v(" "), _c('section', {
    staticClass: "popup-header-content"
  }, [(_vm.level > 0) ? _c('div', {
    staticClass: "content-item",
    class: _vm.isShowProvince ? 'actived' : '',
    on: {
      "click": function($event) {
        _vm.onClickTitle(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.provinceName || '请选择'))]) : _vm._e(), _vm._v(" "), (_vm.level > 1 && _vm.provinceId && _vm.cityList.length > 0) ? _c('div', {
    staticClass: "content-item",
    class: _vm.isShowCity ? 'actived' : '',
    on: {
      "click": function($event) {
        _vm.onClickTitle(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.cityName || '请选择'))]) : _vm._e(), _vm._v(" "), (_vm.level > 2 && _vm.cityId && _vm.districtList.length > 0) ? _c('div', {
    staticClass: "content-item",
    class: _vm.isShowDistrict ? 'actived' : '',
    on: {
      "click": function($event) {
        _vm.onClickTitle(3)
      }
    }
  }, [_vm._v(_vm._s(_vm.districtName || '请选择'))]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "select-panel",
    attrs: {
      "id": "selectPanel"
    },
    on: {
      "touchmove": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.provinceAn
    }
  }, [(_vm.isShowProvince) ? _c('ul', {
    key: "province",
    staticClass: "list-panel",
    style: ({
      width: _vm.bodyWidth + 'px'
    })
  }, _vm._l((_vm.provinceList), function(item, index) {
    return _c('li', {
      staticClass: "list-item",
      class: _vm.cityId == item.code ? 'actived j-provinceList' : ''
    }, [_c('label', {
      staticClass: "name-text",
      on: {
        "click": function($event) {
          _vm.onChoseCity(1, item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.cityId == item.code) ? _c('i', {
      staticClass: "active-icon iconfont"
    }, [_vm._v("")]) : _vm._e()])])
  })) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.cityAn
    }
  }, [(_vm.isShowCity) ? _c('ul', {
    key: "city",
    staticClass: "list-panel",
    style: ({
      width: _vm.bodyWidth + 'px'
    })
  }, _vm._l((_vm.cityList), function(item, index) {
    return _c('li', {
      staticClass: "list-item",
      class: _vm.cityId == item.code ? 'actived j-cityList' : ''
    }, [_c('label', {
      staticClass: "name-text",
      on: {
        "click": function($event) {
          _vm.onClickPanel(2, item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.cityId == item.code) ? _c('i', {
      staticClass: "active-icon iconfont"
    }, [_vm._v("")]) : _vm._e()])])
  })) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.districtAn
    }
  }, [(_vm.isShowDistrict) ? _c('ul', {
    key: "district",
    staticClass: "list-panel",
    style: ({
      width: _vm.bodyWidth + 'px'
    })
  }, _vm._l((_vm.districtList), function(item, index) {
    return _c('li', {
      staticClass: "list-item",
      class: _vm.districtId == item.code ? 'actived j-districtList' : ''
    }, [_c('label', {
      staticClass: "name-text",
      on: {
        "click": function($event) {
          _vm.onClickPanel(3, item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.districtId == item.code) ? _c('i', {
      staticClass: "active-icon iconfont"
    }, [_vm._v("")]) : _vm._e()])])
  })) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShowHeader) ? _c('header', {
    staticClass: "header vux-1px-b",
    style: ([_vm.headerStyle, {
      minHeight: _vm.heigit + 'px'
    }])
  }, [_c('div', {
    staticClass: "back-btn action-btn",
    style: (_vm.leftBtnStyle),
    attrs: {
      "slot": "leftBtn"
    },
    on: {
      "click": _vm.onLeftAction
    },
    slot: "leftBtn"
  }, [_vm._t("leftBtn", [_c('i', {
    staticClass: "icon iconfont"
  }, [_vm._v("")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "nav-title"
  }, [_vm._v(_vm._s(_vm.navTitle))]), _vm._v(" "), _c('div', {
    staticClass: "right-btn action-btn",
    style: (_vm.rightBtnStyle),
    on: {
      "click": _vm.onRightAction
    }
  }, [_vm._t("rightBtn")], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-container"
  }, [_c('img', {
    staticClass: "header-img",
    attrs: {
      "src": _vm.headerImg
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(50)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(53),
  /* scopeId */
  "data-v-3d985552",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(51)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(54),
  /* scopeId */
  "data-v-553781be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(52)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(55),
  /* scopeId */
  "data-v-e9a54226",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(667);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    name: 'Introduce',
    component: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* Introduce */],
    path: '/'
  }, {
    name: 'Submit',
    component: __WEBPACK_IMPORTED_MODULE_2__components__["b" /* Submit */],
    path: '/submit'
  }, {
    name: 'SubmitSuccess',
    component: __WEBPACK_IMPORTED_MODULE_2__components__["c" /* SubmitSuccess */],
    path: '/submitSuccess'
  }, {
    name: 'ShareSuccess',
    component: __WEBPACK_IMPORTED_MODULE_2__components__["d" /* ShareSuccess */],
    path: '/shareSuccess'
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return {
        selector: to.hash
      };
    }

    return {
      x: 0,
      y: 0
    };
  }
}));

/***/ }),

/***/ 594:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(669);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  userPhone: '',
  token: '',
  deviceId: '',
  openFrom: '',
  isShowHeader: false
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_2__getters___default.a,
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* default */]
}));

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_ajax_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Env__ = __webpack_require__(11);












__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_ajax_index_js__["a" /* default */]);

var getUrlParam = function getUrlParam(url, param) {
  var _window$location = window.location,
      search = _window$location.search,
      href = _window$location.href;

  var searchBody = '';
  if (url && url.split('?').length > 1) {
    searchBody = url.split('?')[1];
  } else if (search) {
    searchBody = search.replace('?', '');
  } else if (href && href.split('?').length > 1) {
    searchBody = href.split('?')[1];
  }
  if (!searchBody) return null;
  searchBody = decodeURIComponent(searchBody);
  var searchList = searchBody.split('&');
  var map = {};
  searchList.forEach(function (item) {
    var index = item.indexOf('=');
    var key = item.substr(0, index);
    var value = item.substr(index + 1, item.length);
    map[key] = decodeURIComponent(value);
  });
  return param ? map[param] : map;
};

var getHeader = function getHeader() {
  var map = getUrlParam();
  if (!map) return;

  var header = {
    env: __WEBPACK_IMPORTED_MODULE_6__utils_Env__["a" /* env */].name,
    userid: map.userId,
    deviceid: map.deviceId,
    token: map.token,
    ws_wxapp_ver: map.version,
    pkg_version: map.pkg_version
  };
  return header;
};

var Ax = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */],

  timeout: 1024000,
  withCredentials: true

});

Ax.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  var response = error.response;
  if (response.status === 401) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject('login failed');
  }
  if (response.status === 404) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({
      status: 404
    });
  }
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

var myPromise = {
  then: function then() {
    return myPromise;
  },
  catch: function _catch() {
    return myPromise;
  }
};

var Request = {
  get: function get(url) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Ax.get(url, {
        params: data,
        headers: headers
      }).then(function (res) {
        resolve(res.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  post: function post(url) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = arguments[2];

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      Ax.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data), config).then(function (res) {
        resolve(res.data);
      }).catch(function (err) {
        var msg = err.message || '接口错误';
        reject(msg);
      });
    });
  },

  form: __WEBPACK_IMPORTED_MODULE_5__form__["a" /* default */].form,
  getHeader: getHeader,
  getUrlParam: getUrlParam
};

/* harmony default export */ __webpack_exports__["a"] = (Request);

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(35)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(36),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchVerificationCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loginApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchTickets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return saveFormData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);



var fetchVerificationCode = function fetchVerificationCode() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* Request */].post('/usercenter/smsverifycode/send/v1', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params), {
    headers: headers
  });
};

var loginApp = function loginApp() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* Request */].post('/usercenter/mobile/login/v1', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params), {
    headers: headers
  });
};

var fetchTickets = function fetchTickets() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* Request */].form('/promotion/coupon/send_coupon/v1', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params), {
    headers: headers
  });
};

var saveFormData = function saveFormData() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* Request */].post('/crm/api/thirdparty/code/add/v1', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params), {
    headers: headers
  });
};

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/minishare-logo.png";

/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wxshare-logo.png";

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1236)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(784),
  /* template */
  __webpack_require__(1552),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(99)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(103),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Submit__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Submit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Submit__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Submit___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Introduce__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Introduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Introduce__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Introduce___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubmitSuccess__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubmitSuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SubmitSuccess__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__SubmitSuccess___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShareSuccess__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShareSuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ShareSuccess__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__ShareSuccess___default.a; });





/***/ }),

/***/ 668:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_plugins_toast_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_ajax_index_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_url_param_object__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_url_param_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_url_param_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fastclick__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_minishare_logo_png__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_minishare_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_minishare_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_wxshare_logo_png__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_wxshare_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_wxshare_logo_png__);


















__WEBPACK_IMPORTED_MODULE_5_fastclick___default.a.attach(document.body);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vux_src_plugins_toast_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_ajax_index_js__["a" /* default */]);

var share = __WEBPACK_IMPORTED_MODULE_10__config_js__["a" /* default */].share;


new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_9__App___default.a);
  },

  methods: {
    shareSuccess: function shareSuccess() {
      this.$router.push({
        path: 'shareSuccess'
      });
    },
    setStoreData: function setStoreData() {
      var fromDevice = __WEBPACK_IMPORTED_MODULE_4_url_param_object___default.a.getParamValue('openFrom') || '';
      this.$store.dispatch('SET_FROM', {
        openFrom: fromDevice,
        isShowHeader: fromDevice === 'app'
      });
      this.$store.dispatch('SET_USERINFO', {
        token: __WEBPACK_IMPORTED_MODULE_4_url_param_object___default.a.getParamValue('token') || '',
        deviceId: __WEBPACK_IMPORTED_MODULE_4_url_param_object___default.a.getParamValue('deviceId') || ''
      });
    }
  },
  created: function created() {
    this.setStoreData();
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_6__utils__["g" /* Wechat */].getAppId().then(function (data) {
      var resData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data);
      resData.title = share.title;
      resData.desc = share.desc;
      resData.link = share.linkUrl;
      resData.imgUrl = share.imageWxUrl;
      resData.onSuccess = _this.shareSuccess;
      __WEBPACK_IMPORTED_MODULE_6__utils__["g" /* Wechat */].share(resData);
    });
  }
}).$mount('#app-box');

/***/ }),

/***/ 669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SET_USERINFO: function SET_USERINFO(_ref, data) {
    var commit = _ref.commit;

    commit('SET_USERINFO', data);
  },
  SET_FROM: function SET_FROM(_ref2, data) {
    var commit = _ref2.commit;

    commit('SET_FROM', data);
  },
  SET_USERPHONE: function SET_USERPHONE(_ref3, data) {
    var commit = _ref3.commit;

    commit('SET_USERPHONE', data);
  }
});

/***/ }),

/***/ 670:
/***/ (function(module, exports) {



/***/ }),

/***/ 671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_USERINFO: function SET_USERINFO(state, payload) {
    state.token = payload.token;
    state.deviceId = payload.deviceId;
  },
  SET_FROM: function SET_FROM(state, payload) {
    state.openFrom = payload.openFrom;
    state.isShowHeader = payload.isShowHeader;
  },
  SET_USERPHONE: function SET_USERPHONE(state, payload) {
    state.userPhone = payload;
  }
});

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(96)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(100),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(104),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 784:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_param_object__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_param_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_url_param_object__);




var from = __WEBPACK_IMPORTED_MODULE_0_url_param_object___default.a.getParamValue('openFrom');
var isAndroid = __WEBPACK_IMPORTED_MODULE_0_url_param_object___default.a.getParamValue('system') === 'android';
var statusBarHeight = __WEBPACK_IMPORTED_MODULE_0_url_param_object___default.a.getParamValue('statusBarHeight') || 0;
var height = __WEBPACK_IMPORTED_MODULE_0_url_param_object___default.a.getParamValue('height') || 0;
var SH = height - statusBarHeight;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      isAndroid: isAndroid && from === 'app',
      screenHeight: SH + 'px'
    };
  }
});

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(97)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(101),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ENV = "production";

var BASEURL_MAP = {
  development: '',
  beta: '',
  production: ''
};
/* harmony default export */ __webpack_exports__["a"] = (BASEURL_MAP[ENV]);

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var Cookie = {
  get: function get(key) {
    var arr = document.cookie.match(new RegExp("(^| )" + key + "=([^;]*)(;|$)"));
    if (arr != null) return unescape(arr[2]);
    return null;
  },
  set: function set(key, value) {
    if (!this.get(key)) {
      document.cookie = key + "=" + value;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Cookie);

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});

/***/ }),

/***/ 902:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Application_config_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(38);






var share = __WEBPACK_IMPORTED_MODULE_1__pages_Application_config_js__["a" /* default */].share;


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: '无人货架“蜂”狂来袭'
    };
  },


  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_2__components__["b" /* HeaderBar */]
  },

  methods: {
    onBackEvent: function onBackEvent() {
      __WEBPACK_IMPORTED_MODULE_0__utils__["i" /* Bridge */].invoke('onBack', function () {});
    },
    onShareEvent: function onShareEvent() {
      var _this = this;

      this.getUserInfo();

      __WEBPACK_IMPORTED_MODULE_0__utils__["i" /* Bridge */].invoke('showShareSheet', function (data) {
        _this.shareCb(data);
      }, {
        linkUrl: share.linkUrl,
        title: share.title,
        description: share.desc,
        thumbnailUrl: share.imageWxUrl
      });
    },
    getUserInfo: function getUserInfo() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__utils__["i" /* Bridge */].invoke('getUserInfo', function (resData) {
        _this2.$store.dispatch('SET_USERINFO', resData);
      }, {});
    },
    onGotoSubmit: function onGotoSubmit() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Log */])('app.takeself.h5_application_button');
      this.$router.push({
        path: 'submit'
      });
    },
    shareCb: function shareCb(data) {
      switch (data.status) {
        case 'success':
          this.$router.push({
            path: 'shareSuccess'
          });
          break;
        case 'cancel':
          this.$vux.toast.show({
            position: 'middle',
            type: 'text',
            text: '取消分享'
          });
          break;
        case 'timeout':
        case 'error':
          this.$vux.toast.show({
            position: 'middle',
            type: 'text',
            text: '分享失败'
          });
          break;
        default:
          break;
      }
    }
  }
});

/***/ }),

/***/ 903:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url_param_object__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url_param_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url_param_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Application_api__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(38);









var H5DeviceId = __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* Device */].getDeviceId();

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: '无人货架“蜂”狂来袭',

      userStatus: 1,
      token: '',
      userPhone: '',

      setInterval: null,

      isSendCode: false,
      isRequesting: false,

      isOver: false,
      isLoading: true,

      seconds: 60,

      telephone: '',
      verificationCode: '',
      deviceId: __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* Device */].getId()
    };
  },

  computed: {
    successTitle: function successTitle() {
      var title = '';
      switch (this.userStatus) {
        case 1:
          title = '分享成功';
          break;
        case 2:
          title = '分享成功，请领取优惠券';
          break;
        case 3:
          title = '本周您已通过分享领取过优惠券啦！';
          break;
        case 4:
          title = '领取成功';
          break;
        case 5:
          title = '领取失败';
          break;
        default:
          break;
      }
      return title;
    },
    successDes: function successDes() {
      var des = '';
      switch (this.userStatus) {
        case 1:
        case 4:
          des = '优惠券已到账，请前往「便利蜂APP-我的」或「便利蜂小程序 - 我的」查看';
          break;
        case 2:
          des = '';
          break;
        case 3:
          des = '请前往「便利蜂APP-我的」或「便利蜂小程序-我的」查看';
          break;
        default:
          break;
      }
      return des;
    }
  },

  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_3__components__["b" /* HeaderBar */]
  },

  methods: {
    onBackEvent: function onBackEvent() {
      this.$router.go(-1);
    },
    onStopPropagation: function onStopPropagation(e) {
      e.stopPropagation();
    },
    onGet: function onGet() {
      if (!this.verifyForm()) {
        return false;
      }
      if (!this.verificationCode.trim()) {
        this.showToast('请输入验证码', '10em');
        return false;
      }
      this.loginApp();
      return true;
    },
    showToast: function showToast(text) {
      var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16em';

      this.$vux.toast.show({
        position: 'middle',
        type: 'text',
        width: width,
        text: text
      });
    },
    clearInterval: function (_clearInterval) {
      function clearInterval() {
        return _clearInterval.apply(this, arguments);
      }

      clearInterval.toString = function () {
        return _clearInterval.toString();
      };

      return clearInterval;
    }(function () {
      this.seconds = 60;
      this.isSendCode = false;
      if (this.setInterval) {
        clearInterval(this.setInterval);
        this.setInterval = null;
      }
    }),
    countDown: function countDown() {
      var _this = this;

      this.setInterval = setInterval(function () {
        _this.seconds = _this.seconds - 1;
        if (_this.seconds <= 0) {
          _this.clearInterval();
        }
      }, 1000);
    },
    verifyForm: function verifyForm() {
      if (this.telephone.trim() === '') {
        this.showToast('请输入手机号', '10em');
        return false;
      }
      if (!/^(13|15|18|14|17)\d{9}$/.test(this.telephone)) {
        this.showToast('手机号不正确', '10em');
        return false;
      }
      return true;
    },
    getSuccess: function getSuccess(type) {
      if (type === 1) {
        this.userStatus = 1;
        return;
      }

      if (type === 2) {
        this.userStatus = 4;
      }
      this.clearInterval();
    },
    loginApp: function loginApp() {
      var _this2 = this;

      if (!this.verifyForm()) {
        return;
      }
      if (this.verificationCode === '') {
        this.showToast('验证码为空', '10em');
        return;
      }
      this.isRequesting = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__pages_Application_api__["b" /* loginApp */])({
        mobilePhone: this.telephone,
        smsVerifyCode: this.verificationCode
      }, {
        deviceid: H5DeviceId
      }).then(function (res) {
        _this2.isRequesting = false;
        if (res.status !== 0) {
          _this2.verificationCode = '';
          _this2.showToast(res.msg, '15em');
          return false;
        }
        var data = res.data || {};
        _this2.token = data.token;
        _this2.deviceId = data.deviceId;
        _this2.$store.dispatch('SET_USERPHONE', _this2.telephone);
        _this2.$store.dispatch('SET_USERINFO', data);
        _this2.fetchTickets(2, {
          token: data.token,
          deviceId: data.deviceId
        });
        return true;
      });
      setTimeout(function () {
        _this2.isRequesting = false;
      }, 5000);
    },
    fetchVerificationCode: function fetchVerificationCode() {
      var _this3 = this;

      if (!this.verifyForm()) {
        return;
      }
      this.isSendCode = true;
      this.countDown();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__pages_Application_api__["a" /* fetchVerificationCode */])({
        mobilePhone: this.telephone,
        verifyCodeType: 'MOBILE_LOGIN'
      }, {
        deviceid: H5DeviceId
      }).then(function (res) {
        if (res.status !== 0) {
          _this3.showToast(res.msg, '10em');
          return false;
        }
        return true;
      });
    },
    fetchTickets: function fetchTickets(type, param) {
      var _this4 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__pages_Application_api__["c" /* fetchTickets */])({
        mappingFlag: 'W3xCCmyhHL6ToJ'
      }, {
        token: param.token,
        deviceid: param.deviceId
      }).then(function (res) {
        _this4.isLoading = false;

        if (res.status === 110000) {
          _this4.userStatus = 3;
          return false;
        }

        if (res.status === 110003) {
          _this4.isOver = true;
          return false;
        }
        _this4.isOver = false;
        if (res.status !== 0) {
          _this4.verificationCode = '';
          _this4.userStatus = 5;
          _this4.showToast(res.msg, '16em');
          return false;
        }

        _this4.getSuccess(type);
        return true;
      });
    },
    initData: function initData() {
      this.clearInterval();
      var deviceId = this.$store.state.deviceId;

      if (!deviceId) {
        deviceId = __WEBPACK_IMPORTED_MODULE_1_url_param_object___default.a.getParamValue('deviceId');
      }

      if (!deviceId) {
        deviceId = __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* Device */].getId();
      }

      this.token = this.$store.state.token || __WEBPACK_IMPORTED_MODULE_1_url_param_object___default.a.getParamValue('token');
      this.deviceId = deviceId;

      if (this.token) {
        this.fetchTickets(1, {
          token: this.token,
          deviceId: this.deviceId
        });
        return true;
      }

      this.userStatus = 2;
      this.isLoading = false;
      return false;
    }
  },

  mounted: function mounted() {
    this.initData();
  }
});

/***/ }),

/***/ 904:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_cell_index_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_cell_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_cell_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_popup_index_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_popup_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_popup_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_picker_index_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_picker_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_picker_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Application_api__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(327);














var countList = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].countList;


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: '填写申请',

      isSendCode: false,
      isShowAddreddPanel: false,
      isShowCountPop: false,

      setInterval: null,

      seconds: 60,

      deviceId: __WEBPACK_IMPORTED_MODULE_5__utils__["c" /* Device */].getDeviceId(),
      provinceId: '',
      provinceName: '',

      cityId: '',
      cityName: '',

      districtId: '',
      districtName: '',

      countText: '',
      peopleCount: [],

      personNum: '',
      companyName: '',
      contactName: '',
      contactPhone: '',
      verificationCode: '',

      countList: [countList]
    };
  },


  computed: {
    cityNameStr: function cityNameStr() {
      var temp = [];
      temp.push(this.provinceName);
      temp.push(this.cityName);
      temp.push(this.districtName);
      return temp.join(' ').trim();
    }
  },

  components: {
    Group: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default.a,
    Cell: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_cell_index_vue___default.a,
    Popup: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_popup_index_vue___default.a,
    Picker: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_picker_index_vue___default.a,
    AddressSelect: __WEBPACK_IMPORTED_MODULE_4__components__["c" /* AddressSelect */],
    HeaderBar: __WEBPACK_IMPORTED_MODULE_4__components__["b" /* HeaderBar */]
  },

  methods: {
    onStopPropagation: function onStopPropagation(e) {
      e.stopPropagation();
    },
    onBackEvent: function onBackEvent() {
      this.$router.go(-1);
    },
    onSubmit: function onSubmit() {
      if (!this.verifyForm()) {
        return false;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* Log */])('app.takeself.h5_application_detail_apply', {
        city: this.cityName,
        company_name: this.companyName,
        people_count: this.countText,
        user_name: this.contactName,
        phone_number: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["m" /* encryptPhone */])(this.contactPhone)
      });
      this.loginApp();
      return true;
    },
    onOpenAddress: function onOpenAddress() {
      this.isShowAddreddPanel = true;
      this.$refs.addressPanel.initData({
        provinceId: this.provinceId,
        cityId: this.cityId,
        districtId: this.districtId,
        provinceName: this.provinceName,
        districtName: this.districtName,
        cityName: this.cityName
      });
    },
    onCloseAddress: function onCloseAddress(data) {

      if (data.type === 4) {
        this.isShowAddreddPanel = false;
        return;
      }
      this.provinceId = data.provinceId || '';
      this.provinceName = data.provinceName || '';
      this.cityId = data.cityId || '';
      this.cityName = data.cityName || '';
      this.districtId = data.districtId || '';
      this.districtName = data.districtName || '';
      this.isShowAddreddPanel = false;
    },
    onClickCount: function onClickCount() {
      this.isShowCountPop = true;
      this.peopleCount = [this.countText];
    },
    onCloseCount: function onCloseCount() {
      this.isShowCountPop = false;
    },
    onChangeCount: function onChangeCount(item) {
      if (item[0] === '请选择公司常驻人数') {
        this.countText = '';
        this.personNum = '';
      } else {
        this.countText = item[0];
        this.personNum = countList.indexOf(item[0]) - 1;
      }
    },
    showToast: function showToast(text) {
      var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16em';

      this.$vux.toast.show({
        position: 'middle',
        type: 'text',
        width: width,
        text: text
      });
    },
    clearInterval: function (_clearInterval) {
      function clearInterval() {
        return _clearInterval.apply(this, arguments);
      }

      clearInterval.toString = function () {
        return _clearInterval.toString();
      };

      return clearInterval;
    }(function () {
      this.seconds = 60;
      this.isSendCode = false;
      if (this.setInterval) {
        clearInterval(this.setInterval);
        this.setInterval = null;
      }
    }),
    countDown: function countDown() {
      var _this = this;

      this.setInterval = setInterval(function () {
        _this.seconds = _this.seconds - 1;
        if (_this.seconds <= 0) {
          _this.clearInterval();
        }
      }, 1000);
    },
    verifyForm: function verifyForm() {

      if (!this.cityId) {
        this.showToast('请选择所在城市');
        return false;
      }
      if (this.companyName.trim() === '') {
        this.showToast('请输入公司名称');
        return false;
      }

      if (this.companyName.trim().length > 50) {
        this.showToast('公司名称最多输入50个字', '18em');
        return false;
      }

      if (this.personNum === '') {
        this.showToast('请选择公司常驻人数');
        return false;
      }

      if (!this.contactName.trim()) {
        this.showToast('请输入联系人姓名');
        return false;
      }

      if (this.contactName.trim().length > 50) {
        this.showToast('联系人姓名最多输入50个字', '18em');
        return false;
      }

      if (!this.verifyPhone()) {
        return false;
      }

      if (!this.verificationCode) {
        this.showToast('请输入验证码');
        return false;
      }

      return true;
    },
    verifyPhone: function verifyPhone() {
      if (this.contactPhone.trim() === '') {
        this.showToast('请输入手机号');
        return false;
      }
      if (!/^(13|15|18|14|17)\d{9}$/.test(this.contactPhone)) {
        this.showToast('手机号有误，请重新输入', '18em');
        return false;
      }
      return true;
    },
    loginApp: function loginApp() {
      var _this2 = this;

      if (this.verificationCode === '') {
        this.showToast('验证码为空', '10em');
        return;
      }
      this.isRequesting = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__pages_Application_api__["b" /* loginApp */])({
        mobilePhone: this.contactPhone,
        smsVerifyCode: this.verificationCode
      }, {
        deviceid: this.deviceId
      }).then(function (res) {
        _this2.isRequesting = false;
        if (res.status !== 0) {
          _this2.verificationCode = '';
          _this2.showToast(res.msg, '15em');
          return false;
        }
        var data = res.data || {};
        _this2.deviceId = data.deviceId;
        _this2.$store.dispatch('SET_USERPHONE', _this2.contactPhone);
        _this2.saveInfo();
        return true;
      });
      setTimeout(function () {
        _this2.isRequesting = false;
      }, 5000);
    },
    fetchVerificationCode: function fetchVerificationCode() {
      var _this3 = this;

      if (this.verifyPhone()) {
        this.isSendCode = true;
        this.countDown();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__pages_Application_api__["a" /* fetchVerificationCode */])({
          mobilePhone: this.contactPhone,
          verifyCodeType: 'MOBILE_LOGIN'
        }, {
          deviceid: this.deviceId
        }).then(function (res) {
          if (res.status !== 0) {
            _this3.showToast(res.msg, '18em');
            return false;
          }
          return true;
        });
      }
    },
    saveInfo: function saveInfo() {
      var _this4 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__pages_Application_api__["d" /* saveFormData */])({
        provinceCode: this.provinceId,
        cityCode: this.cityId,
        companyName: this.companyName,
        personNum: this.personNum,
        contactName: this.contactName,
        contactPhone: this.contactPhone
      }).then(function (res) {
        if (res.status !== 0) {
          var msg = res.msg || '接口异常，请稍后重试';
          _this4.verificationCode = '';
          _this4.showToast(msg, '18em');
          return false;
        }
        _this4.$router.push({
          path: 'submitSuccess'
        });
        return true;
      }).catch(function () {
        _this4.verificationCode = '';
        _this4.showToast('接口异常，请稍后重试', '18em');
      });
    }
  },

  mounted: function mounted() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* Log */])('app.takeself.h5_application_detail');
    this.clearInterval();
  }
});

/***/ }),

/***/ 905:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(38);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: '提交成功',

      userPhone: ''
    };
  },


  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_1__components__["b" /* HeaderBar */]
  },

  methods: {
    onGoHome: function onGoHome() {
      this.$router.push({
        path: '/'
      });
    },
    onBack: function onBack() {
      this.$router.go(-1);
    }
  },

  mounted: function mounted() {
    this.userPhone = this.$store.state.userPhone;
  }
});

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'inline-desc'
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popup__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_dom__ = __webpack_require__(135);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new __WEBPACK_IMPORTED_MODULE_1__popup__["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;

      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && __WEBPACK_IMPORTED_MODULE_2__libs_dom__["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && __WEBPACK_IMPORTED_MODULE_2__libs_dom__["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[668]);


// WEBPACK FOOTER //
// static/js/pages/Application/main.9f13950d5785f7a6136d.js